// extracted by mini-css-extract-plugin
module.exports = {"root":"BulkModal_root__1WcwU","checkboxContainer":"BulkModal_checkboxContainer__2eHny"};